const pageAccordion = () => {
  const parent = document.querySelector('.page-nav__list');
  const dropEl = document.querySelectorAll('.drop-js');
  parent.addEventListener('click', (event) => {
    const target = event.target;
    //dropEl.classList.toggle('page-nav__item_active');
    if (target && target.classList.contains('drop-js')) {
      target.classList.toggle('page-nav__item_active');
    }
    if (target && target.classList.contains('page-nav__link')) {
      target.parentNode.classList.toggle('page-nav__item_active');
    }
    //dropEl.forEach(element => element.classList.toggle('page-nav__item_active'));
  });

};
export default pageAccordion;